import React from 'react';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  className?: string;
}
export function CtaButton({
  children,
  href = '#oferta',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-4 text-sm sm:px-8 sm:py-5 sm:text-lg' : 'px-5 py-3 text-[0.8rem] sm:px-6 sm:text-sm';
  return <a href={href} className={`group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gold-400 text-center font-bold uppercase tracking-wide text-forest-950 shadow-lift transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-gold-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-400 active:translate-y-0 sm:w-auto ${sizing} ${className}`} style={{
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  }} data-id="element-55" data-mp="cn5bv97eyb08">
      {children}
    </a>;
}